var map = {
	"./av_amala.png": 87430,
	"./av_bell.png": 99154,
	"./av_bhoecha.png": 47246,
	"./av_butterlamp.png": 34350,
	"./av_chorten.png": 17278,
	"./av_crane.png": 15016,
	"./av_dog.png": 63245,
	"./av_dorjee.png": 55066,
	"./av_fearmask.png": 59581,
	"./av_female.png": 43661,
	"./av_incense.png": 78852,
	"./av_lungta.png": 91696,
	"./av_male.png": 91539,
	"./av_mask.png": 6143,
	"./av_momola.png": 49090,
	"./av_monk.png": 77056,
	"./av_monkhat.png": 32922,
	"./av_mount_kailash.png": 43773,
	"./av_pala.png": 32016,
	"./av_popola.png": 58250,
	"./av_prayerbeads.png": 81763,
	"./av_prayerflag.png": 55010,
	"./av_prayers.png": 10691,
	"./av_prayerwheel.png": 61517,
	"./av_shoes.png": 70872,
	"./av_tea.png": 16367,
	"./av_tent.png": 97801,
	"./av_tsampa.png": 22534,
	"./av_yak.png": 23120,
	"./av_yungbulakang.png": 12910
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88261;